import { CustomerTypesService } from './../../../../../services/modules/stocks/customer-types.service';
import { CustomerType } from './../../../../../models/modules/customerType';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { TabPosition, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { augmentForKendo, DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { AddressSummary } from '~/models/modules/address';
import { CategoryListing } from '~/models/modules/category';
import { CustomerSummary } from '~/models/modules/customer';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { UnitOfMeasureListing } from '~/models/modules/unitOfMeasure';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FormatService } from '~/services/administration.ts/format';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { CustomersService } from '~/services/modules/stocks/customers';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { ReturnTransactionsService } from '~/services/modules/stocks/return-transactions';
import { SalesOrdersService } from '~/services/modules/stocks/sales-orders';
import { UnitOfMeasuresService } from '~/services/modules/stocks/unit-of-measure';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { GDataService } from '~/services/GDataService';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';

@Component({
    selector: 'customer-edit-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StocksCustomersUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _selectedAccounts: any[] = [];
  _selectedAccountIds: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _selectedAddresses: any[] = [];
  _selectedAddressesKeys: number[] = [];
  _theme: string;
  _form: FormGroup;
  _addressForm: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _showImagesGrid: boolean;
  _showAddressesGrid: boolean;
  _addresses: AddressSummary[] = [];
  _addressesFiltered: AddressSummary[];
  _categories: CategoryListing[];
  _categoriesFiltered: CategoryListing[];
  _unitOfMeasures: UnitOfMeasureListing[];
  _receiveUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _inventoryUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _issueUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _customerTypes: any[];
  _contractWith: any[] = [];
  _contractWithFiltered: any[] = [];
  _listOfLeadVars: Array<string> = [
    'hours',
    'days',
    'weeks',
    'months',
    'years',
  ];
  _editFormActive: boolean;
  _addressGridData: any[];
  declare _tabEnabled: boolean;
  _currentType: string;
  _currentTab: Record<string, boolean> = {};
  _invalidForm: boolean;
  _model: CustomerSummary = null;
  _customersCode = new FormControl();
  _customerType = new FormControl();
  _pageState: PageState;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any = [];
  _customValidation: any = [];
  _selectedLabelId: number;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _page = 'customers';
  _permissionScope = 'customers';
  _customTabs: any;
  _orderingTabsForm: boolean = false;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedLabelObjectCode: any;
  _language = 'en';
  _gridFieldText: GridFieldTextSummary[];
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _isMandatory: boolean = false;
  _requiredFieldNames: Array<any> = [];
  _requiredFields: Array<any> = [];
  _customRequiredFields: Array<any> = [];
  _isEditForms: boolean = false;
  _defaultCustomerTypeSettingEnabled: boolean;
  _showCustomerTypesGrid: boolean = false;
  _selectedCustomerTypes: CustomerType[] = [];
  _selectedContractWithFromModal: any[] = [];
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  _customerTypeAuth: GridFieldAuthorization;
  _showContractWithGrid: boolean;
  copyModelId: number;
  //#region _donutChartSmall
  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];
  //#endregion
  //#region  _donutChartLarge
  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];
  //#endregion
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _selectedContractWith: any;


  _NOSOSActive: boolean = true;
  _IIPCActive: boolean = false;
  _IIBPNActive: boolean = false;
  _BOActive: boolean = false;
  _TRANSHISTORYActive: boolean = false;
  SONumberPerDate: any;
  IssuedItemPerDate: any;
  IssuedItemByItemIdPerDate: any;
  BackordersPerCustomer: any;
  IssueTransactionsPerCustomer: any;

  /* AddressSystemFields: Array<any> = [
    { title: 'CusAddress1' },
    { title: 'CusAddress2' },
    { title: 'CusCity' },
    { title: 'CusState' },
    { title: 'CusZip' },
    { title: 'CusCountry' },
    { title: 'CusPhone1' },
    { title: 'CusPhone2' },
    { title: 'CusFax' },
    { title: 'CusEmail' },
    { title: 'CusWebsite' }
  ]; */

  /* ContractSystemFields: Array<any> = [
    { title: 'CusContractPerson' },
    { title: 'CusContractDate' },
    { title: 'CusContractExpDate' }
  ];
  TruckSystemFields: Array<any> = [
    { title: 'CusTruckMake' },
    { title: 'CusTruckModel' },
    { title: 'CusTruckColor' },
    { title: 'CusTruckVin' },
    { title: 'CusTruckLicencePlate' },
  ];
  ContactInfoSystemFields: Array<any> = [
    { title: 'CusContact' },
    { title: 'CusConPhone1' },
    { title: 'CusConPhone2' },
    { title: 'CusConFax' },
    { title: 'CusConEmail' },
  ]; */


  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];

  _isLiveEnterprise: boolean;

  _datePickerFormat: string;
  _costFormat: string;

  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  _showEnterpriseCharts = false;


  soChartForm: boolean = false;
  soBackOrderChartForm: boolean = false;
  transactionHistoryChartForm: boolean = false;

  numberOfSoChartDetail: StartEndDateChartResponseModel;
  numberOfSoChart: Chart;

  issueItemsByCategoryChartDetail: StartEndDateChartResponseModel;
  issueItemsByCategoryChart: Chart;
  issueItemsByCategorySecondChart: Chart;


  issueItemsByStockNumberChartDetail: StartEndDateChartResponseModel;
  issueItemsByStockNumberChart: Chart;
  issueItemsByStockNumberSecondChart: Chart;


  numberOfSoBackOrderByCategoryChartDetail: StartEndDateChartResponseModel;
  numberOfSoBackOrderByCategoryChart: Chart;


  transactionHistoryByCategoryChartDetail: StartEndDateChartResponseModel;
  transactionHistoryByCategoryChart: Chart;


  _poGridColumns: GridFieldSummary[];
  _soGridColumns: GridFieldSummary[];
  _issueGridColumns: GridFieldSummary[];
  _returnGridColumns: GridFieldSummary[];
  _customerTypesGridColumns: GridFieldSummary[];
  _contractWithGridColumns: GridFieldSummary[];
  _addressesGridColumns: GridFieldSummary[];

  isNumberOfSoGridExpanded: boolean = true;
  isNumberOfSoChartExpanded: boolean = true;

  isBackOrderGridExpanded: boolean = true;
  isBackOrderChartExpanded: boolean = true;

  isTransactionHistoryGridExpanded: boolean = true;
  isTransactionHistoryChartExpanded: boolean = true;


  reactivate: boolean = false;
  reactivateItem: any;


  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Customer_ID') kendoBarcodeGenCustomerID: ElementRef;
  @ViewChild('Kendo_Combobox_Customer_Type') KendoComboboxCustomerType: ComboBoxComponent;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('Kendo_Customer_Name_Input') KendoCustomerNameInput: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;

  _additionalErrors: any = [];
  //#region Multi Site Variables

  //#endregion
  constructor(
    private _accountsService: AccountsService,
    private _customersService: CustomersService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _filesService: FilesService,
    private _addressesService: AddressesService,
    private _categoriesService: CategoriesService,
    private _unitOfMeasuresService: UnitOfMeasuresService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _issueTransactionService: IssueTransactionsService,
    private _returnTransactionService: ReturnTransactionsService,
    private _salesOrdersService: SalesOrdersService,
    private _customerTypesService: CustomerTypesService,
    private _dataService: GDataService,
    private _multiSitesService: MultiSiteService
  ) {
    super();
    this._currentUser = this._securityService.currentUser;
    this._gridFields
      .getGridFieldsByPage('customerTypes')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('customerTypes', data);
      });
    this._gridFields
      .getGridFieldsByPage('addresses')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('addresses', data);
      });



    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('customerTypes', (gridColumns) => {
      this._customerTypesGridColumns = gridColumns;
    }));
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('addresses', (gridColumns) => {
      this._addressesGridColumns = gridColumns;
    }));
    this._customerTypesService.customerTypeAdded.subscribe(x => {
      const customerType = { code: x.code, id: x.id, name: x.name };
      this._customerTypes.push(customerType);
      this._form.controls.customerType.setValue(customerType);
      this._customerTypeChange(customerType);
    });
    //////////////////////
    this._gridFields
      .getGridFieldsByPage('customers')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('customers', data);
      });



    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('customers', (gridColumns) => {
      this._contractWithGridColumns = gridColumns;
    }));
    // this._customerTypesService.customerTypeAdded.subscribe(x => {
    //   const customerType = { code: x.code, id: x.id, name: x.name};
    //   this._customerTypes.push(customerType);
    //   this._form.controls.customerType.setValue(customerType);
    //   this._customerTypeChange(customerType);
    // })
  }
  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }
    if (this._pageState == PageState.COPY && this._model) {
      if (this._model.entityContact != undefined)
        this._model['entityContact'].id = 0;
      if (this._model.customerContract != undefined)
        this._model['customerContract'].id = 0;
      if (this._model.entityTruck != undefined)
        this._model['entityTruck'].id = 0;
      if (this._model.entityAddress != undefined)
        this._model['entityAddress'].id = 0;

      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;

    }


    if (this._model && this._model.id) {
      this.LoadNumberOfSoChart();
      this.LoadIssueItemsByCategoryByCustomer();
      this.LoadIssueItemsByStockNumberByCustomer();
      this.LoadSoBackOrderByCustomer();
      this.LoadTransactionHistoryByCustomer();
      this._selectedAddressesKeys = this._model.addressIds;
      // this._siteSelected = this._model.site;

    }
    if (!this._currentUser.isEnterprise) {
      if (this._model && this._model.site) {
        this._loadFormSites(true, this._model.site);
      }
      else {
        this._loadFormSites();
      }
    }
  }

  ngAfterContentChecked(): void {
    //this.cdRef.detectChanges();
  }

  ngOnInit() {
    this._viewInactiveFormTabs(true);
    this._dataService.dataTransferObservable.subscribe((data: any) => {
      if (data.component == 'addresses' && typeof data.addressData === 'object') {
        let item = data.addressData;
        let addressExists = this._selectedAddressesKeys.find(r => r == item.id);
        let addressExistsInGrid = this._addressGridData.find(r => r.id == item.id);
        if (addressExists == undefined && addressExistsInGrid == undefined) {
          this._selectedAddressesKeys.push(item.id);
          this._addressGridData.push({
            id: item.id,
            name: item.name,
            addressLine1: item.addressLine1,
            addressLine2: item.addressLine2,
            city: item.city,
            state: item.state,
            zip: item.zip,
            country: item.country,
            phone1: item.phone1,
            phone2: item.phone2,
            email: item.email,
            website: item.website,
            fax: item.fax
          });
        }
      }
    });
    //#region Test
    this._isLiveEnterprise = environment.liveEnterprise;

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.customerSites ?? []).map((item: any) => ({
        siteId: item.site?.id ?? item.siteId,
        accountId: item.account?.id ?? item.accountId
      }));
      this._selectedAccountIds = this._selectedAccounts.map((a: any) => +a.accountId);
      this._tabEnabled = this._selectedAccounts.length > 0;
    }
    this._currentUser = this._securityService.currentUser;

    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();


    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });

    /** Decleration _model when open from another component */
    if (!this._model)
      this._model = new CustomerSummary();

    if (!this._currentUser.isEnterprise && this._model.id) {
      this._customersService.getSONumberPerDate(this._model.id).subscribe((x: any) => {
        this.SONumberPerDate = x;
      });

      this._customersService.getIssuedItemPerDate(this._model.id).subscribe((x: any) => {
        this.IssuedItemPerDate = x;
      });

      this._customersService.getIssuedItemsPerstockitemIdPerDate(this._model.id).subscribe((x: any) => {
        this.IssuedItemByItemIdPerDate = x;
      });

      this._customersService.getBackordersPerCustomer(this._model.id).subscribe((x: any) => {
        this.BackordersPerCustomer = x;
      });

      this._customersService.getIssueTransactionsPerCustomer(this._model.id).subscribe((x: any) => {
        this.IssueTransactionsPerCustomer = x;
      });
    }
    this.getAuth();
    this.getCustomerTypeAuth();

    //#endregion
    this._currentTab['Customer Info'] = false;

    this._LoadCustomerTypesDD();
    this._initForm();


    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenCustomerID.nativeElement.focus();
      }, 500);

    }

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    //this.setMandatoryFields();
    // setTimeout(() => {
    //   let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
    //   tabElementList.children[1].classList.add("mendatoryTab");
    // });

    setTimeout(() => {
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {
          if (child.firstChild.innerText == 'Customer Info') {
            child.classList.add('mendatoryTab');
          }
        });
      }

    });
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }

    if (!this._currentUser.isEnterprise) {
      // const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
      // if (loggedInAccountSites != '') {
      //   let customerAccountIds = new Array();
      //   customerAccountIds.push((JSON.parse(loggedInAccountSites)[0].accountId));
      //   let model = { accountIds: customerAccountIds };
      //   return this._customersService.getAccountCustomers(model)
      //     .subscribe((data: any) => {
      //       this._contractWith = data;
      //       if(this._pageState == PageState.EDIT || PageState.VIEW){
      //         var currentCustomer = this._contractWith.find(f => f.id == this._model.id);
      //         if(currentCustomer != undefined){
      //           let indx = this._contractWith.indexOf(currentCustomer);
      //           this._contractWith.splice(indx,1);
      //         }
      //       }
      //     });
      // }
    }
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
  }
  getCustomersBySite() {
    if (this._currentUser.isEnterprise) {
      let model = { accountIds: this._selectedAccounts.map((x) => x.accountId) };
      return this._customersService
        .getAccountCustomers(model)
        .subscribe((data: any) => {
          this._contractWith = data;

          if (this._pageState == PageState.EDIT || PageState.VIEW) {
            var currentCustomer = this._contractWith.find(f => f.id == this._model.id);
            if (currentCustomer != undefined) {
              let indx = this._contractWith.indexOf(currentCustomer);
              this._contractWith.splice(indx, 1);
            }
          }
          this._contractWithFiltered = this._contractWith;
        });
    }
    else {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
      if (loggedInAccountSites != '') {
        let customerAccountIds = new Array();
        customerAccountIds.push((JSON.parse(loggedInAccountSites)[0].accountId));
        let model = { accountIds: customerAccountIds, siteId: this._siteSelected?.id };
        return this._customersService.getAccountCustomers(model)
          .subscribe((data: any) => {
            this._contractWith = data;
            if (this._pageState == PageState.EDIT || PageState.VIEW) {
              var currentCustomer = this._contractWith.find(f => f.id == this._model.id);
              if (currentCustomer != undefined) {
                let indx = this._contractWith.indexOf(currentCustomer);
                this._contractWith.splice(indx, 1);
              }
            }
            this._contractWithFiltered = this._contractWith;
          });
      }
    }
    if (this._form.controls['contractwith'].value
      && this._contractWith
      && !this._contractWith.find(x => x.id == this._form.controls['contractwith'].value.id)) {
      this._form.controls['contractwith'].setValue(null);
    }
  }
  _loadFormSites(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this.getCustomersBySite();
  }
  _handleSitesChange(event: any) {
    super._handleSitesChange(event);
    this.getCustomersBySite();
  }

  //#endregion
  _NOSOSTabClick() {
    this._NOSOSActive = true;
    this._IIPCActive = false;
    this._IIBPNActive = false;
    this._BOActive = false;
    this._TRANSHISTORYActive = false;
  }

  _IIPCTabClick() {
    this._NOSOSActive = false;
    this._IIPCActive = true;
    this._IIBPNActive = false;
    this._BOActive = false;
    this._TRANSHISTORYActive = false;
  }

  _IIBPNTabClick() {
    this._NOSOSActive = false;
    this._IIPCActive = false;
    this._IIBPNActive = true;
    this._BOActive = false;
    this._TRANSHISTORYActive = false;
  }

  _BOTabClick() {
    this._NOSOSActive = false;
    this._IIPCActive = false;
    this._IIBPNActive = false;
    this._BOActive = true;
    this._TRANSHISTORYActive = false;
  }

  _TRANSHISTORYTabClick() {
    this._NOSOSActive = false;
    this._IIPCActive = false;
    this._IIBPNActive = false;
    this._BOActive = false;
    this._TRANSHISTORYActive = true;
  }
  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  _edit() {
    this._pageState = PageState.EDIT;
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }
  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(this._selectedAccounts.map(x => x.accountId), params, model);
  }

  _getAccountAddresses = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._addressesService.getAccountsAddresses(this._selectedAccounts.map(x => x.accountId), params, model);
  }

  _getAddresses = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._addressesService.getAddresses(params, model);
  }

  _getSelectedImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getPictures(params, model);
  }

  _getSelectedAddresses = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._addressesService.getAddresses(params, model);
  }

  _handleCategoryFilter(value: any) {
    this._categoriesFiltered = this._categories.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleReceiveUnitOfMeasuresFilter(value: any) {
    this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleInventoryUnitOfMeasuresFilter(value: any) {
    this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleIssueUnitOfMeasuresFilter(value: any) {
    this._issueUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _barcodeSubmited() {
    this._customersCode.setValue(this._form.get('code').value);
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoCustomerNameInput.nativeElement.focus();
        let CustomerName = this.KendoCustomerNameInput;
        CustomerName.nativeElement.classList.add('focusedInput');
      });
    }
  }




  async LoadTransactionHistoryByCustomer() {
    this._customersService.GetTransactionHistoryByCustomer(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        this.transactionHistoryByCategoryChartDetail = data;
        this.transactionHistoryByCategoryChart = this.transactionHistoryByCategoryChartDetail.chart;
      });


    this._gridFields
      .getGridFieldsByPage('issueHistory')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('issueHistory', data);
        this._issueGridColumns = data;
      });


    this._gridFields
      .getGridFieldsByPage('returnHistory')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('returnHistory', data);
        this._returnGridColumns = data;
      });

  }

  _getReturnTransactions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.transactionHistoryByCategoryChartDetail.startDate,
      endDate: this.transactionHistoryByCategoryChartDetail.endDate
    };
    return this._returnTransactionService.GetReturnTransactionByStockItem(this._model.id, startEndDate);
  }




  _getIssueTransactions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.transactionHistoryByCategoryChartDetail.startDate,
      endDate: this.transactionHistoryByCategoryChartDetail.endDate
    };
    return this._issueTransactionService.GetIssueTransactionByCustomer(this._model.id, startEndDate);
  }



  async LoadSoBackOrderByCustomer() {
    this._customersService.GetNumberOfSoBackOrderByCustomer(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {

        this.numberOfSoBackOrderByCategoryChartDetail = data;
        this.numberOfSoBackOrderByCategoryChart = this.numberOfSoBackOrderByCategoryChartDetail.chart;
      });
  }



  async LoadIssueItemsByCategoryByCustomer() {
    this._customersService.GetIssueItemsByCategoryByCustomer(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        // data.chart.yaxis.labels.show = true;
        // data.chart.yaxis.tickPlacement = 'on';
        // let toolbar: any = {
        //   show: true,
        //   offsetX: 0,
        //   offsetY: 0,
        //   tools: {
        //     download: true,
        //     selection: true,
        //     zoom: true,
        //     zoomin: true,
        //     zoomout: true,
        //     pan: true,
        //     // reset: true,
        //     // customIcons: []
        //   },
        // };
        //data.chart.toolbar = toolbar;


        this.issueItemsByCategoryChartDetail = data;
        this.issueItemsByCategoryChart = this.issueItemsByCategoryChartDetail.chart;
        this.issueItemsByCategorySecondChart = this.issueItemsByCategoryChartDetail.secondChart;

        await this.FillChartSeriesChart(this.issueItemsByCategoryChart);
        await this.FillIssuedItemsByCategoryChartSettings();
        await this.FillChartDataLabels(this.issueItemsByCategoryChart);
        await this.FillChartSeriesForQuarter(this.issueItemsByCategorySecondChart);
        // let a = [0];
        // this.issueItemsByCategoryChart.series[0].data = a;




      });

  }



  async LoadIssueItemsByStockNumberByCustomer() {
    this._customersService.GetIssueItemsByStockNumberByCustomer(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {

        this.issueItemsByStockNumberChartDetail = data;
        this.issueItemsByStockNumberChart = this.issueItemsByStockNumberChartDetail.chart;
        this.issueItemsByStockNumberSecondChart = this.issueItemsByStockNumberChartDetail.secondChart;

        await this.FillChartSeriesChart(this.issueItemsByStockNumberChart);
        await this.FillIssuedItemsByStockNumberChartSettings();
        await this.FillChartDataLabels(this.issueItemsByStockNumberChart);
        await this.FillChartSeriesForQuarter(this.issueItemsByStockNumberSecondChart);
        // let a = [0];
        // this.issueItemsByStockNumberChart.series[0].data = a;
      });

  }




  async FillIssuedItemsByStockNumberChartSettings() {
    var chartSettings: any = {
      id: 'stockNumberBar',
      height: 280,
      type: 'bar',
      events: {
        dataPointSelection: (e: any, chart: any, opts: any) => {
          var quarterChartEl = document.querySelector('#chart-quarter');
          var monthChartEl = document.querySelector('#chart-issuedItem');

          if (opts.selectedDataPoints[0].length === 1) {
            if (quarterChartEl.classList.contains('active')) {
              this.updateQuarterChart(chart, 'barQuarter');
            } else {
              monthChartEl.classList.add('chart-quarter-activated');
              quarterChartEl.classList.add('active');
              this.updateQuarterChart(chart, 'barQuarter');
            }
          } else {
            this.updateQuarterChart(chart, 'barQuarter');
          }

          if (opts.selectedDataPoints[0].length === 0) {
            monthChartEl.classList.remove('chart-quarter-activated');
            quarterChartEl.classList.remove('active');
          }
        },
        updated: (chart: any) => {
          this.updateQuarterChart(chart, 'barQuarter');
        }
      }
    };


    this.issueItemsByStockNumberChart.chart = chartSettings;
  }


  async FillChartSeriesChart(chart: Chart) {
    var series: any = [
      {
        name: chart.series[0].name,
        data: chart.series[0].data
      }
    ];


    chart.series = series;
  }

  async FillIssuedItemsByCategoryChartSettings() {
    var chartSettings: any = {
      id: 'categoryBar',
      height: 280,
      type: 'bar',
      events: {
        dataPointSelection: (e: any, chart: any, opts: any) => {
          var quarterChartEl = document.querySelector('#chart-quarter');
          var monthChartEl = document.querySelector('#chart-issuedItem');

          if (opts.selectedDataPoints[0].length === 1) {
            if (quarterChartEl.classList.contains('active')) {
              this.updateQuarterChart(chart, 'barQuarter');
            } else {
              monthChartEl.classList.add('chart-quarter-activated');
              quarterChartEl.classList.add('active');
              this.updateQuarterChart(chart, 'barQuarter');
            }
          } else {
            this.updateQuarterChart(chart, 'barQuarter');
          }

          if (opts.selectedDataPoints[0].length === 0) {
            monthChartEl.classList.remove('chart-quarter-activated');
            quarterChartEl.classList.remove('active');
          }
        },
        updated: (chart: any) => {
          this.updateQuarterChart(chart, 'barQuarter');
        }
      }
    };

    this.issueItemsByCategoryChart.chart = chartSettings;
  }


  async FillChartDataLabels(chart: Chart) {
    var dataLabels: any = {
      enabled: true,
      textAnchor: 'start',
      formatter: function (val: any, opt: any) {
        return opt.w.globals.labels[opt.dataPointIndex];
      }
    };
    chart.dataLabels = dataLabels;
  }


  async FillChartSeriesForQuarter(chart: Chart) {
    var series: any = [
      {
        name: 'quarter',
        data: []
      }
    ];

    chart.series = series;
  }


  public updateQuarterChart(sourceChart: any, destChartIDToUpdate: any) {
    var series = [];
    var seriesIndex = 0;
    var colors = [];

    if (sourceChart.w.globals.selectedDataPoints[0]) {
      var selectedPoints = sourceChart.w.globals.selectedDataPoints;
      for (var i = 0; i < selectedPoints[seriesIndex].length; i++) {
        var selectedIndex = selectedPoints[seriesIndex][i];
        var yearSeries = sourceChart.w.config.series[seriesIndex];
        series.push({
          name: yearSeries.data[selectedIndex].x,
          data: yearSeries.data[selectedIndex].quarters
        });
        colors.push(yearSeries.data[selectedIndex].color);
      }

      if (series.length === 0)
        series = [
          {
            data: []
          }
        ];

      return (window as any).ApexCharts.exec(destChartIDToUpdate, 'updateOptions', {
        series: series,
        colors: colors,
        fill: {
          colors: colors
        }
      });
    }
  }

  async LoadNumberOfSoChart() {
    this._customersService.GetNumberOfSoByCustomer(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {

        this.numberOfSoChartDetail = data;
        this.numberOfSoChart = data.chart;
      });

    this._gridFields
      .getGridFieldsByPage('salesOrders')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('salesOrders', data);
        this._soGridColumns = data;
      });


  }



  _getSalesOrders = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.numberOfSoChartDetail.startDate,
      endDate: this.numberOfSoChartDetail.endDate
    };
    return this._salesOrdersService.GetSalesOrderByCustomer(this._model.id, startEndDate);
  }



  _getSalesOrdersBackOrder = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.numberOfSoBackOrderByCategoryChartDetail.startDate,
      endDate: this.numberOfSoBackOrderByCategoryChartDetail.endDate
    };
    return this._salesOrdersService.GetSalesOrderBackOrderByCustomer(this._model.id, startEndDate);
  }


  TransactionHistoryChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.transactionHistoryChartForm = true;
  }

  TransactionHistoryFormClose() {
    this.transactionHistoryChartForm = false;
  }



  SoBackOrderChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.soBackOrderChartForm = true;
  }

  SoBackOrderChartFormClose() {
    this.soBackOrderChartForm = false;
  }


  SoChartFormOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.soChartForm = true;
  }

  SoChartFormClose() {
    this.soChartForm = false;
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._customersCode.setValue(data.result.toString());
        this._form.patchValue({
          code: data.result.toString()
        });
        if (this._pageState == PageState.ADD) {
          setTimeout(() => {
            this.KendoCustomerNameInput.nativeElement.focus();
            let CustomerName = this.KendoCustomerNameInput;
            CustomerName.nativeElement.classList.add('focusedInput');
          });
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('customers', quantity);
  }
  _removeTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let CustomerName = this.KendoCustomerNameInput;
      CustomerName.nativeElement.classList.add('focusedInput');
      this.KendoCustomerNameInput.nativeElement.focus();
    }
  }
  _CustomerNameSubmited() {
    if (this._pageState == PageState.ADD) {
      let CustomerName = this.KendoCustomerNameInput;
      CustomerName.nativeElement.classList.remove('focusedInput');
      CustomerName.nativeElement.blur();
      this._addClassActive = true;
    }
  }
  _CustomerNameFocusout() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let CustomerName = this.KendoCustomerNameInput;
        CustomerName.nativeElement.classList.remove('focusedInput');
        CustomerName.nativeElement.blur();
      }, 100);
    }
  }
  _skipCustomerName() {
    if (this._pageState == PageState.ADD) {
      let CustomerName = this.KendoCustomerNameInput;
      CustomerName.nativeElement.classList.remove('focusedInput');
      CustomerName.nativeElement.blur();
      this._addClassActive = true;
    }
  }
  _LoadCategoriesDD() {
    const accountIds = this._selectedAccounts.map(x => x.accountId);
    return this._categoriesService.getAccountCategories(accountIds)
      .subscribe((data: any) => {
        this._categories = data;
        this._categoriesFiltered = this._categories;
      });
  }

  _LoadUnitOfMeasuresDD() {
    const accountIds = this._selectedAccounts.map(x => x.accountId);
    return this._unitOfMeasuresService.getAccountUnitOfMeasures(accountIds)
      .subscribe((data: any) => {
        this._unitOfMeasures = data;
        this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures;
        this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures;
        this._issueUnitOfMeasuresFiltered = this._unitOfMeasures;
      });
  }

  _LoadCustomerTypesDD() {
    let model = { accountIds: this._selectedAccounts.map(x => x.accountId) };
    return this._customersService.getAccountCustomerTypes(model)
      .subscribe((data: any) => {
        this._customerTypes = data;
      });
  }

  _LoadCustomersDD() {
    let model = { accountIds: this._selectedAccounts.map(x => x.accountId) };
    return this._customersService.getAccountCustomers(model)
      .subscribe((data: any) => {
        this._contractWith = data;
        this._contractWithFiltered = this._contractWith;
      });
  }
  _handContractWithFilter(value: any) {
    this._contractWithFiltered = this._contractWith.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = true;
    }
  }

  _selectAddressesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showAddressesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showAddressesGrid = true;
    }

  }
  _addNewAddress() {

  }
  _returnSelectedImagesHandler(e: any): void {
    if (this._selectedAccounts.length) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
    } else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please choose the account with the site desired',
        withoutConfirm: true
      });
    }
  }

  _returnSelectedAddressesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showAddressesGrid = false;
        this._selectedAddresses.forEach((f: any) => {
          this._selectedAddressesKeys.push(f);
        });
        // this._selectedAddressesKeys = this._selectedAddresses;
        this._loadSelectedAddress();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showAddressesGrid = false;
      this._selectedAddresses.forEach((f: any) => {
        this._selectedAddressesKeys.push(f);
      });
      //this._selectedAddressesKeys = this._selectedAddresses;
      this._loadSelectedAddress();
    }
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();

    if (e.title != 'Customer Info') {
      // this._currentTab['Customer Info'] = false;
    }

    if (e.title == 'Customer Info') {
      //this._loadSelectedAddress();
      this._loadRequiredCustInfoTab();
    }
    if (e.title == 'Ship To Info') {
      this._loadSelectedAddress();
    }
  }
  _loadRequiredCustInfoTab() {
    if (this._pageState == PageState.ADD) {
      if (this._form.get('customerType').value == null) {
        setTimeout(() => {
          this.KendoComboboxCustomerType.toggle(true);
          this.KendoComboboxCustomerType.focus();
        });
      }
    }
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _closeImagesWindow(): void {
    this._showImagesGrid = false;
  }

  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }

  _closeAddressesWindow(): void {
    this._showAddressesGrid = false;
  }

  _onAddressRowSelectionChanges(e: any[]) {
    this._selectedAddresses = [];
    e.forEach((item) => {
      this._selectedAddresses.push(+item);
    });
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() {
    if (this._currentUser.isEnterprise) {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired, then press General',
          withoutConfirm: true
        });
      } else {
        this._editFormActive = true;
        this._layoutManager.applyOverly();
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._editFormActive = true;
      this._layoutManager.applyOverly();
    }
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm(model?: any) {
    var closeComponent = {
      component: 'customers',
      isClosed: true,
      response: model
    };
    this._isDialiog = false;
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('customers');
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._customersService.customerFormClosed(this._form.get('code').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e, () => {
      this._LoadCustomersDD();
    });
  }

  _loadSelectedAddress() {
    let modelParam: any = {
      deleted: 'false',
      pageSize: this._selectedAddressesKeys.length
    };

    const model = {
      filter: {},
      selectedIds: this._selectedAddressesKeys
    };

    this._addressesService.getAddresses(modelParam, model)
      .pipe(map(augmentForKendo))
      .subscribe((data: any) => {
        this._addresses = data.data.value ?? data.data;

        this._loadAddressesDropDown();
      });
  }

  _loadAddressesDropDown(search?: string) {
    let modelParam: any = {
      search: search,
      deleted: 'false'
    };

    const model = {
      filter: {},
    };

    this._addressesService.getAddresses(modelParam, model)
      .pipe(map(augmentForKendo))
      .subscribe((data: any) => {
        if (data) {
          if (!search) {
            data.data.forEach((v: any) => {
              if (!this._addresses.find(x => x.id == v.id)) {
                this._addresses.push(v);
              }
            });
          } else {
            this._addresses = data.data;
          }
        }

        if (this._addresses.length) {
          this._addressesFiltered = this._addresses.map((x: any) => x.name);
        }

        //  if (!this._addressGridData || this._addressGridData.length == 0) {
        this._loadAddressesGrid();
        //}
      });
  }

  _loadAddressesGrid() {
    if (this._addresses.length) {
      if (this._addressGridData == undefined) {
        this._addressGridData = [];
      }
      this._addresses.filter(x => this._selectedAddressesKeys.includes(x.id)).forEach((item) => {
        let addressExistsInGrid = this._addressGridData.find(r => r.id == item.id);
        if (addressExistsInGrid == undefined) {
          this._addressGridData.push({
            id: item.id,
            name: item.name,
            addressLine1: item.addressLine1,
            addressLine2: item.addressLine2,
            city: item.city,
            state: item.state,
            zip: item.zip,
            country: item.country,
            phone1: item.phone1,
            phone2: item.phone2,
            email: item.email,
            website: item.website,
            fax: item.fax
          });
        }
      });
    }
  }

  _handleAddressesFilters(value: any) {
    this._loadAddressesDropDown(value);
  }

  _handleAddressSelection(value: any, id: number) {

    if (id) {
      const newAddress = this._addresses.find(x => x.name == value);
      if (this._selectedAddressesKeys.find(x => x === newAddress.id)) {
        this._layoutComponent.openPopup({
          title: 'Duplicate',
          message: 'This Address is already selected!',
          withoutConfirm: true
        });
      } else {

        ///////////////////////////////////
        this._addressGridData.find((x: any) => x.id == id).id = newAddress.id;
        this._addressGridData.find((x: any) => x.id == id).name = newAddress.name;
        this._addressGridData.find((x: any) => x.id == id).addressLine1 = newAddress.addressLine1;
        this._addressGridData.find((x: any) => x.id == id).addressLine2 = newAddress.addressLine2;
        this._addressGridData.find((x: any) => x.id == id).city = newAddress.city;
        this._addressGridData.find((x: any) => x.id == id).state = newAddress.state;
        this._addressGridData.find((x: any) => x.id == id).zip = newAddress.zip;
        this._addressGridData.find((x: any) => x.id == id).country = newAddress.country;
        this._addressGridData.find((x: any) => x.id == id).phone1 = newAddress.phone1;
        this._addressGridData.find((x: any) => x.id == id).phone2 = newAddress.phone2;
        this._addressGridData.find((x: any) => x.id == id).email = newAddress.email;
        this._addressGridData.find((x: any) => x.id == id).website = newAddress.website;
        this._addressGridData.find((x: any) => x.id == id).fax = newAddress.fax;

        this._selectedAddressesKeys.push(newAddress.id);
        this._selectedAddressesKeys = this._selectedAddressesKeys.filter(x => x != id);
      }
    }
    else {
      const newAddress = this._addresses.find(x => x.name == value);
      if (this._selectedAddressesKeys.find(x => x === newAddress.id)) {
        this._layoutComponent.openPopup({
          title: 'Duplicate',
          message: 'This Address is already selected!',
          withoutConfirm: true
        });
      }
      else {
        this._addressForm.get('id').setValue(this._addresses.find(v => v.name == value).id);
        this._addressForm.get('name').setValue(this._addresses.find(v => v.name == value).name);
        this._addressForm.get('addressLine1').setValue(this._addresses.find(v => v.name == value).addressLine1);
        this._addressForm.get('addressLine2').setValue(this._addresses.find(v => v.name == value).addressLine2);
        this._addressForm.get('city').setValue(this._addresses.find(v => v.name == value).city);
        this._addressForm.get('state').setValue(this._addresses.find(v => v.name == value).state);
        this._addressForm.get('zip').setValue(this._addresses.find(v => v.name == value).zip);
        this._addressForm.get('country').setValue(this._addresses.find(v => v.name == value).country);
        this._addressForm.get('phone1').setValue(this._addresses.find(v => v.name == value).phone1);
        this._addressForm.get('phone2').setValue(this._addresses.find(v => v.name == value).phone2);
        this._addressForm.get('email').setValue(this._addresses.find(v => v.name == value).email);
        this._addressForm.get('website').setValue(this._addresses.find(v => v.name == value).website);
        this._addressForm.get('fax').setValue(this._addresses.find(v => v.name == value).fax);
        //////////////////////////////
        // let id = '';
        // this._addressGridData.find((x: any) => x.id == id).id = newAddress.id;
        // this._addressGridData.find((x: any) => x.id == id).name = newAddress.name;
        // this._addressGridData.find((x: any) => x.id == id).addressLine1 = newAddress.addressLine1;
        // this._addressGridData.find((x: any) => x.id == id).addressLine2 = newAddress.addressLine2;
        // this._addressGridData.find((x: any) => x.id == id).city = newAddress.city;
        // this._addressGridData.find((x: any) => x.id == id).state = newAddress.state;
        // this._addressGridData.find((x: any) => x.id == id).zip = newAddress.zip;
        // this._addressGridData.find((x: any) => x.id == id).country = newAddress.country;
        // this._addressGridData.find((x: any) => x.id == id).phone1 = newAddress.phone1;
        // this._addressGridData.find((x: any) => x.id == id).phone2 = newAddress.phone2;
        // this._addressGridData.find((x: any) => x.id == id).email = newAddress.email;
        // this._addressGridData.find((x: any) => x.id == id).website = newAddress.website;
        // this._addressGridData.find((x: any) => x.id == id).fax = newAddress.fax;

        this._selectedAddressesKeys.push(newAddress.id);
        this._selectedAddressesKeys = this._selectedAddressesKeys.filter(x => x != newAddress.id);
      }
    }
  }

  _customerTypeChange(value: any): void {
    this._currentType = value ? value.code : null;

    this._currentTab['Customer Info'] = false;
    if (this._currentType === 'Activity' || this._currentType === 'Dispose' || this._currentType === 'Person' || this._currentType === 'Company' || this._currentType === 'Contract' || this._currentType === 'Truck') {
      this._currentTab['Customer Info'] = true;
    }
  }
  private closeEditor(grid: GridComponent, rowIndex = this.editedRowIndex) {
    // close the editor
    grid.closeRow(rowIndex);
    // reset the helpers
    this.editedRowIndex = undefined;
    this._addressForm = undefined;
  }
  _addHandler({ sender }: any) {
    this.closeEditor(sender);
    this._addressForm = this._fb.group({
      id: '',
      name: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      phone1: '',
      phone2: '',
      email: '',
      website: '',
      fax: ''
    });

    sender.addRow(this._addressForm);

    this._addressForm.get('name').valueChanges.subscribe((x) => {
      const newAddress = this._addresses.find(v => v.name == x);

      if (this._selectedAddressesKeys.find(x => x === newAddress.id)) {
        this._layoutComponent.openPopup({
          title: 'Duplicate',
          message: 'This Address is already selected!',
          withoutConfirm: true
        });
      } else {
        this._addressForm.get('id').setValue(this._addresses.find(v => v.name == x).id);
        this._addressForm.get('name').setValue(this._addresses.find(v => v.name == x).name);
        this._addressForm.get('addressLine1').setValue(this._addresses.find(v => v.name == x).addressLine1);
        this._addressForm.get('addressLine2').setValue(this._addresses.find(v => v.name == x).addressLine2);
        this._addressForm.get('city').setValue(this._addresses.find(v => v.name == x).city);
        this._addressForm.get('state').setValue(this._addresses.find(v => v.name == x).state);
        this._addressForm.get('zip').setValue(this._addresses.find(v => v.name == x).zip);
        this._addressForm.get('country').setValue(this._addresses.find(v => v.name == x).country);
        this._addressForm.get('phone1').setValue(this._addresses.find(v => v.name == x).phone1);
        this._addressForm.get('phone2').setValue(this._addresses.find(v => v.name == x).phone2);
        this._addressForm.get('email').setValue(this._addresses.find(v => v.name == x).email);
        this._addressForm.get('website').setValue(this._addresses.find(v => v.name == x).website);
        this._addressForm.get('fax').setValue(this._addresses.find(v => v.name == x).fax);
      }
    });
  }

  _cancelHandler({ sender, rowIndex }: any) {
    sender.closeRow(rowIndex);
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }
  private editedRowIndex: number;
  _saveHandler({ sender, formGroup, rowIndex }: any) {
    if (this._selectedAddressesKeys.find(x => x === this._addressForm.get('id').value)) {
      this._layoutComponent.openPopup({
        title: 'Duplicate',
        message: 'This Address is already selected!',
        withoutConfirm: true
      });
    } else {
      if (this._addressForm.valid) {
        let addressId = this._addressForm.get('id').value;
        let addressExists = this._selectedAddressesKeys.find(r => r == addressId);
        let addressExistsInGrid = this._addressGridData.find(r => r.id == addressId);
        if (addressExists == undefined && addressExistsInGrid == undefined) {
          this._addressGridData.push({
            id: addressId,
            name: this._addressForm.get('name').value,
            addressLine1: this._addressForm.get('addressLine1').value,
            addressLine2: this._addressForm.get('addressLine2').value,
            city: this._addressForm.get('city').value,
            state: this._addressForm.get('state').value,
            zip: this._addressForm.get('zip').value,
            country: this._addressForm.get('country').value,
            phone1: this._addressForm.get('phone1').value,
            phone2: this._addressForm.get('phone2').value,
            email: this._addressForm.get('email').value,
            website: this._addressForm.get('website').value,
            fax: this._addressForm.get('fax').value,
          });
          this._selectedAddressesKeys.push(this._addressForm.get('id').value);
        }
        sender.closeRow(rowIndex);
      }
    }
  }

  _removeHandler({ sender, dataItem }: any) {
    this._addressGridData = this._addressGridData.filter((x: any) => x.id != dataItem.id);
    //this._selectedAddressesKeys = this._selectedAddressesKeys.filter(x => x != dataItem.id);
    this._selectedAddressesKeys = this._addressGridData.map((x: any) => x.id);
    sender.cancelCell();
  }

  private _initForm() {
    this._form = this._fb.group({
      code: [this._model && this._model.code, Validators.required],
      name: [this._model && this._model.name, this.getLabel('LBL_CusName')?.isRequired ? Validators.required : null],
      addressLine1: [this._model && this._model.entityAddress?.addressLine1, this.getLabel('LBL_CusAddress1')?.isRequired ? Validators.required : null],
      addressLine2: [this._model && this._model.entityAddress?.addressLine2, this.getLabel('LBL_CusAddress2')?.isRequired ? Validators.required : null],
      city: [this._model && this._model.entityAddress?.city, this.getLabel('LBL_CusCity')?.isRequired ? Validators.required : null],
      state: [this._model && this._model.entityAddress?.state, this.getLabel('LBL_CusState')?.isRequired ? Validators.required : null],
      zip: [this._model && this._model.entityAddress?.zip, this.getLabel('LBL_CusZip')?.isRequired ? Validators.required : null],
      country: [this._model && this._model.entityAddress?.country, this.getLabel('LBL_CusCountry')?.isRequired ? Validators.required : null],
      lat: new FormControl(),
      lng: new FormControl(),
      phone1: [this._model && this._model.entityAddress?.phone1, this.getLabel('LBL_CusPhone1')?.isRequired ? Validators.required : null],
      phone2: [this._model && this._model.entityAddress?.phone2, this.getLabel('LBL_CusPhone2')?.isRequired ? Validators.required : null],
      email: [this._model && this._model.entityAddress?.email, this.getLabel('LBL_CusEmail')?.isRequired ? Validators.required : null],
      website: [this._model && this._model.entityAddress?.website, this.getLabel('LBL_CusWebsite')?.isRequired ? Validators.required : null],
      fax: [this._model && this._model.entityAddress?.fax, this.getLabel('LBL_CusFax')?.isRequired ? Validators.required : null],
      contractwith: [this._model && this._model.customerContract, this.getLabel('LBL_CusContractPerson')?.isRequired ? Validators.required : null],
      contractdate: [this._model && this._model.customerContract?.date ? new Date(this._model.customerContract?.date) : null, this.getLabel('LBL_CusContractDate')?.isRequired ? Validators.required : null],
      expiredate: [this._model && this._model.customerContract?.expireDate ? new Date(this._model.customerContract?.expireDate) : null, this.getLabel('LBL_CusContractExpDate')?.isRequired ? Validators.required : null],
      truckmake: [this._model && this._model.entityTruck?.truckMake, this.getLabel('LBL_CusTruckMake')?.isRequired ? Validators.required : null],
      truckmodel: [this._model && this._model.entityTruck?.truckModel, this.getLabel('LBL_CusTruckModel')?.isRequired ? Validators.required : null],
      truckcolor: [this._model && this._model.entityTruck?.truckColor, this.getLabel('LBL_CusTruckColor')?.isRequired ? Validators.required : null],
      truckvin: [this._model && this._model.entityTruck?.truckVin, this.getLabel('LBL_CusTruckVin')?.isRequired ? Validators.required : null],
      trucklicenseplate: [this._model && this._model.entityTruck?.truckLicensePlate, this.getLabel('LBL_CusTruckLicencePlate')?.isRequired ? Validators.required : null],
      customerType: [this._model && this._model.customerType, Validators.required],
      entityAddress: [this._model && this._model.entityAddress],
      contactphone1: [this._model && this._model.entityContact?.phone1, this.getLabel('LBL_CusConPhone1')?.isRequired ? Validators.required : null],
      contactphone2: [this._model && this._model.entityContact?.phone2, this.getLabel('LBL_CusConPhone2')?.isRequired ? Validators.required : null],
      //contactfax: new FormControl(),
      contactfax: [this._model && this._model.entityContact?.fax, this.getLabel('LBL_CusConFax')?.isRequired ? Validators.required : null],
      contactemail: [this._model && this._model.entityContact?.email, this.getLabel('LBL_CusConEmail')?.isRequired ? Validators.required : null],
      contactwebsite: new FormControl(),
      //contactperson: new FormControl(),
      contactperson: [this._model && this._model.entityContact?.person, this.getLabel('LBL_CusContact')?.isRequired ? Validators.required : null]
    });

    if (this._model.customerType) {
      this._customerType.setValue(this._model.customerType);
      this._customerTypeChange(this._model.customerType);
    }
    if (this._model.addressIds) {
      if (!this._addressGridData || this._addressGridData.some((x: any) => !this._model.addressIds.includes(x.id))) {
        this._addressesService.getAddressesSummary().subscribe(res => {
          this._addressGridData = this._addressGridData || [];
          for (let i = 0; i < this._model.addressIds.length; i++) {
            let addressExistsInGrid = this._addressGridData.find(r => r.id == this._model.addressIds[i]);
            if (addressExistsInGrid == undefined) {
              this._addressGridData.push(res.find((x: any) => x.id == this._model.addressIds[i]));
            }
          }
        });
      }
    }

    if (this._model.customerContract && this._model.customerContract.customerWithId) {
      this._customersService.getCustomer(this._model.customerContract.customerWithId).subscribe(res => {
        this._selectedContractWith = res;
      });
    }
  }

  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.'
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } //else if (this._custominvalidForm && this._customValidation.find((x: any) => !x.value) )
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    } else {

      // work with custom fields
      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        // for (const [index, [key, value]] of entries.entries()) {
        //   this._customFieldsDictionary[key] = `${value}`;
        // }
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      //
      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountSites'] = [];
      var tmpAccountSites = this._selectedAccounts.filter(
        (x: any) => x.siteId != -1
      );
      tmpAccountSites.forEach((item) => {
        if (model['accountSites'].filter(
          (x: any) => x.siteId == item.siteId && x.accountId == item.accountId
        ).length == 0) {
          model['accountSites'].push(item);
        }
      });
      model['customerTypeId'] = model.customerType.id;
      if (model.entityContact == undefined) {
        model['entityContact'] = {};
        model['entityContact'].id = this._pageState == PageState.EDIT ? this._model?.entityContact?.id : 0;
      }
      model['entityContactId'] = this._pageState == PageState.EDIT ? this._model?.entityContact?.id : 0;
      if (model.entityAddress == undefined) {
        model.entityAddress = {};
        model['entityAddress'].id = this._pageState == PageState.EDIT ? this._model?.entityAddress?.id : 0;
      }
      model['entityAddressId'] = this._pageState == PageState.EDIT ? this._model?.entityAddress?.id : 0;
      if (model.customerContract == undefined) {
        model['customerContract'] = {};
        model['customerContract'].id = this._pageState == PageState.EDIT ? this._model?.customerContract?.id : 0;
      }
      model['customerContractId'] = this._pageState == PageState.EDIT ? this._model?.customerContract?.id : 0;
      if (model.entityTruck == undefined) {
        model['entityTruck'] = {};
        model['entityTruck'].id = this._pageState == PageState.EDIT ? this._model?.entityTruck?.id : 0;
      }
      model['entityTruckId'] = this._pageState == PageState.EDIT ? this._model?.entityTruck?.id : 0;
      if (this._currentType === 'Company' || this._currentType === 'Person') {
        model['addressIds'] = this._selectedAddressesKeys;//.filter((item, i, arr) => arr.findIndex(t => t === item) === i);
      }

      if (this._currentType === 'Activity' || this._currentType === 'Person' || this._currentType === 'Company' || this._currentType === 'Dispose') {
        model['entityAddress'] = {
          addressLine1: model.addressLine1,
          addressLine2: model.addressLine2,
          city: model.city,
          state: model.state,
          zip: model.zip,
          country: model.country,
          phone1: model.phone1,
          phone2: model.phone2,
          fax: model.fax,
          email: model.email,
          website: model.website,
          id: this._pageState == PageState.EDIT ? model.entityAddress?.id : 0
        };
      }

      if (this._currentType === 'Company') {
        model['entityContact'] = {
          id: this._pageState == PageState.EDIT ? this._model?.entityContact?.id : 0,
          person: model.contactperson,
          phone1: model.contactphone1,
          phone2: model.contactphone2,
          fax: model.contactfax,
          email: model.contactemail
        };
      }
      else if (this._currentType !== 'Company' && model.entityContact == undefined) {
        model['entityContact'] = {
          id: 0,
          person: null,
          phone1: null,
          phone2: null,
          fax: null,
          email: null
        };
      }
      if (this._currentType === 'Contract') {
        model['customerContract'] = {
          id: this._pageState == PageState.EDIT ? this._model?.customerContract?.id : 0,
          customerwithid: model.contractwith?.customerWithId ? model.contractwith?.customerWithId
            : null,
          date: model.contractdate?.toLocaleDateString(),
          expiredate: model.expiredate?.toLocaleDateString()
        };
      }
      if (this._currentType === 'Truck') {
        model['entityTruck'] = {
          id: this._pageState == PageState.EDIT ? this._model?.entityTruck?.id : 0,
          truckmake: model.truckmake,
          truckmodel: model.truckmodel,
          truckcolor: model.truckcolor,
          truckvin: model.truckvin,
          trucklicenseplate: model.trucklicenseplate
        };
      }
      model["siteId"] = this._siteSelected?.id;

      if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
        if (this._model.entityAddress)
          model['entityAddressId'] = this._model.entityAddress.id;
        this._customersService
          .updateCustomer(this._model.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.customerShipToAddresses = response.extraData;
                  this._customersService.customerUpdated.emit(model);
                  if (e === 'save') {
                    this._pageState = PageState.EDIT;
                  }
                  if (e === 'saveAndClose') {
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.code.setValue(null);
                    if (this._model.entityContact != undefined)
                      this._model['entityContact'].id = 0;
                    if (this._model.customerContract != undefined)
                      this._model['customerContract'].id = 0;
                    if (this._model.entityTruck != undefined)
                      this._model['entityTruck'].id = 0;
                    if (this._model.entityAddress != undefined)
                      this._model['entityAddress'].id = 0;
                    this._pageState = PageState.ADD;
                    this.copyModelId = this._model.id;
                    this.loadCustomFields();
                  }
                  else if (e === 'saveAndNew') {
                    this._active = false;
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                } else {
                  return;
                }
              }
            }
            else if (response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
            }
            // this._closeForm();
          });
      } else {
        this._customersService
          .createCustomer(model)

          .subscribe((response: any) => {

            if (response != null && response['message'] != null) {
              if (!this._currentUser.isEnterprise) {
                this.note.createNote(response.responseId);
              }
              model.id = response.responseId;
              model.customerShipToAddresses = response.extraData;
              this._customersService.customerAdded.emit(model);
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              /** Close & Save */
              if (response['close'] != null) {
                if (response['close'] == true) {
                  if (e === 'save') {
                    this._active = false;
                    this._isDialiog = false;
                    this.openUpsert(this._page, response.extraData, PageState.EDIT);
                    /* this._pageState = PageState.EDIT;
                    model.id = response.responseId;
                    this._model = response.extraData;
                    //this._model.entityAddress.id = response.extraData.entityAddress.id;
                    alert(response.responseId); */
                  }
                  else if (e === 'saveAndClose') {
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.code.setValue(null);
                    if (this._model.entityContact != undefined)
                      this._model['entityContact'].id = 0;
                    if (this._model.customerContract != undefined)
                      this._model['customerContract'].id = 0;
                    if (this._model.entityTruck != undefined)
                      this._model['entityTruck'].id = 0;
                    if (this._model.entityAddress != undefined)
                      this._model['entityAddress'].id = 0;
                    this._pageState = PageState.ADD;
                    //this.loadCustomFields();
                  }
                  else if (e === 'saveAndNew') {
                    this._active = false;
                    this.openUpsert(this._page, {}, PageState.ADD);
                  }
                } else {
                  return;
                }
              }
            }
            else if (response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
            }
            // this._closeForm();
          });
      }
    }
  }

  // _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
  //   Object.keys(customFieldsValue).forEach(key => {
  //     let customObject = {
  //       Key: key,
  //       Value: customFieldsValue[key],
  //     };
  //     let item = null;
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined
  //     || this._customFields[tabId].find((x) => x.name == key).customFieldsData.length == 0)
  //      {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1 ,customFieldId:-1});
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //     var requiredCustomerField = this._customValidation.find(
  //       (x: any) => x.name == key
  //     );
  //     if (requiredCustomerField) {
  //       let item2 = null;
  //       this._customValidation.forEach((element: any) => {
  //         if (element.name == key) {
  //           item2 = element;
  //         }
  //       });
  //       if (item2 != null) {
  //         let index2 = this._customValidation.indexOf(item2);
  //         if (index2 != -1) {
  //           this._customValidation[index2].value = customObject.Value;
  //         }

  //       }
  //     }
  //   });
  //   this._customFieldsValue = customFieldsValue;
  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'customers' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             // this._closeForm();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });

  // }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        data = data.filter(x => x.formTab?.page == this._page);

        if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data.map(item => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });


  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }



  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {


      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.setMandatoryFields();
      });
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      });
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this._systemFields.find(x => x.id === oldLocData.id).formOrder
      = sysFClone.find(x => x.id === newLocData.id).formOrder;
    this._systemFields.find(x => x.id === newLocData.id).formOrder
      = sysFClone.find(x => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }
  requiredSystemTabs: any = [];
  setMandatoryFields() {
    //this.getSystemFields();
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {

      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {
          if (child.firstChild.innerText == 'Customer Info')
            child.classList.add('mendatoryTab');

          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add('mendatoryTab');
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);

  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = false;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._active = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _closeDialog(event: boolean) {
    this._isDialiog = false;
  }



  getStateString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.state;
      counter++;
    });

    return accounts;
  }


  getCountryString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.country;
      counter++;
    });

    return accounts;
  }

  getZipString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.zip;
      counter++;
    });

    return accounts;
  }

  getCityString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.city;
      counter++;
    });

    return accounts;
  }


  getAddress1String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine1;
      counter++;
    });

    return accounts;
  }


  getAddress2String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine2;
      counter++;
    });

    return accounts;
  }

  ExpandCollapseNumberOfSoGrid(isExpand: boolean) {
    this.isNumberOfSoGridExpanded = !isExpand;
  }


  ExpandCollapseNumberOfSoChart(isExpand: boolean) {
    this.isNumberOfSoChartExpanded = !isExpand;
  }


  ExpandCollapseBackOrderGrid(isExpand: boolean) {
    this.isBackOrderGridExpanded = !isExpand;
  }


  ExpandCollapseBackOrderChart(isExpand: boolean) {
    this.isBackOrderChartExpanded = !isExpand;
  }


  ExpandCollapseTransactionHistoryGrid(isExpand: boolean) {
    this.isTransactionHistoryGridExpanded = !isExpand;
  }


  ExpandCollapseTransactionHistoryChart(isExpand: boolean) {
    this.isTransactionHistoryChartExpanded = !isExpand;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
  _selectCustomerTypesHandler(): void {
    this._showCustomerTypesGrid = true;
  }
  _closeCustomerTypesWindow(): void {
    this._showCustomerTypesGrid = false;
  }
  _returnSelectedCustomerTypesHandler(e: any[]): void {

    this._showCustomerTypesGrid = false;
    this._selectedCustomerTypes.forEach((item: any) => {
      this._form.controls.customerType.setValue(item);
    });
    this._customerTypeChange(this._form.controls.customerType.value);
  }
  _getCustomerTypes = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      return this._customerTypesService.getCustomerTypedatagrid(params, model);
    }
  }
  _onCustomerTypeRowSelectionChanges(e: any[]) {
    this._selectedCustomerTypes = [];
    e.forEach((item) => {
      this._selectedCustomerTypes.push(item);
    });
  }
  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD };
  }
  getCustomerTypeAuth() {
    this._gridFields.getFileAuthorization('mnuCustomerTypes', this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization) => {
        this._customerTypeAuth = x;
      });
  }

  _selectContractWithHandler(): void {
    this._showContractWithGrid = true;
  }
  _closeContractWithWindow(): void {
    this._showContractWithGrid = false;
  }
  _returnSelectedContractWithHandler(e: any[]): void {

    this._showContractWithGrid = false;
    this._selectedContractWithFromModal.forEach((item: any) => {
      this._form.controls.contractwith.setValue(item);
    });
    //this._customerTypeChange(this._form.controls.customerType.value);
  }
  _getCustomers = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      //   if(this._currentUser.isEnterprise)
      //   {
      //     model.accountIds = this._selectedAccountIds;
      //   }
      //   else
      //   {
      //     model.allSitesDropDownSiteId  = this._siteSelected?.id;
      //   }

      return this._customersService.getCustomers(params, model, this._siteSelected?.id);
    }
  }
  _onContractWithRowSelectionChanges(e: any[]) {
    this._selectedContractWithFromModal = [];
    e.forEach((item) => {
      this._selectedContractWithFromModal.push(item);
    });
  }
}


